
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["lds-wedges",classNames,staticClass],
              style: [{"background":"0 0"},style,staticStyle],
              attrs: Object.assign({"width":"200","height":"200","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid","style":"background:0 0"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"rotate(119.909 38.162 46.838) scale(.7)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","calcMode":"linear","values":"0 50 50;360 50 50","keyTimes":"0;1","dur":"0.75s","begin":"0s","repeatCount":"indefinite"}}),_c('path',{attrs:{"d":"M50 50V0a50 50 0 0150 50z","fill-opacity":".8","fill":"rgba(92.7741935483871%,39.90453529146133%,19.07997565429093%,0.894)"}})]),_c('g',{attrs:{"transform":"rotate(-90.068 49.991 35.009) scale(.7)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","calcMode":"linear","values":"0 50 50;360 50 50","keyTimes":"0;1","dur":"1s","begin":"0s","repeatCount":"indefinite"}}),_c('path',{attrs:{"d":"M50 50h50a50 50 0 01-50 50z","fill-opacity":".8","fill":"#389798"}})]),_c('g',{attrs:{"transform":"rotate(59.954 29.498 55.502) scale(.7)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","calcMode":"linear","values":"0 50 50;360 50 50","keyTimes":"0;1","dur":"1.5s","begin":"0s","repeatCount":"indefinite"}}),_c('path',{attrs:{"d":"M50 50v50A50 50 0 010 50z","fill-opacity":".8","fill":"#55ac2d"}})]),_c('g',{attrs:{"transform":"rotate(-150.023 44.508 40.492) scale(.7)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","calcMode":"linear","values":"0 50 50;360 50 50","keyTimes":"0;1","dur":"3s","begin":"0s","repeatCount":"indefinite"}}),_c('path',{attrs:{"d":"M50 50H0A50 50 0 0150 0z","fill-opacity":".8","fill":"#e8c647"}})])])
          )
        }
      }
    